import qs from "qs";
import request from "@/utils/request";

/* 我的账号 */
export function myAccountApi(data) {
  return request({
    url: "/account/user/info",
    method: "post",
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  });
}
/* 更新账号 */
export function updateAccountApi(data) {
  return request({
    url: "/account/update",
    method: "post",
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data
  });
}
/* 身份认证 */
export function identityApi(params) {
  return request({
    url: "/account/idcard/auth",
    method: "post",
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    params
  });
}
/* 获取banner列表 */
export function getBannerApi(params) {
  return request({
    url: "/banner/v1/get/list",
    method: "post",
    params
  });
}
/* 修改密码 */
export function forgetPwdApi(params) {
  return request({
    url: "/account/forget/password",
    method: "post",
    params
  });
}

/* 绑定支付宝 */
export function bindAlipayApi(params) {
  return request({
    url: "/bindAlipayUserId",
    method: "post",
    params
  });
}

/* 校验邀请码 */
export function checkInviteCode(params) {
  return request({
    url: "/oauth/checkInviteCode",
    method: "post",
    params
  });
}

/* 修改手机号 */
export function editPhoneApi(params) {
  return request({
    url: "/account/forget/phone",
    method: "post",
    params
  });
}
